import { useDataChange } from 'Simple/Data'

/** @type {import('Simple/types.js').useDataOnChange} */
export default function useDataOnChange(props, data) {
  let change = useDataChange({
    context: 'selected',
    viewPath: props.viewPath,
  })

  return async function onChange(value) {
    change(next => {
      next.filtered_tasks = value
      next.board_ids = value?.map(item => item.board.id)
      next.bulk_stages =
        value
          // need to figure out how to determine if the tasks selected are all from the same board,
          // if that's the case we can enable the stage picker as well
          // ?.filter(item => selected_tasks?.includes(item.id))
          ?.map(item => item.board.id)?.length === 1
          ? value[0].board.stages
          : []
    })
  }
}
